export default __webpack_public_path__ + "static/media/june.3181f103.png";